import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyLabels = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 41,
	viewBox: "0 0 65 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_580_65099)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M32.3447 40.5269C50.0178 40.5269 64.3447 37.4162 64.3447 33.5789C64.3447 29.7416 50.0178 26.6309 32.3447 26.6309C14.6716 26.6309 0.344727 29.7416 0.344727 33.5789C0.344727 37.4162 14.6716 40.5269 32.3447 40.5269Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.8202 6.71287C34.2992 6.71287 33.8231 6.91049 33.4549 7.27877L18.2744 22.4592C17.9061 22.8275 17.7085 23.3036 17.7085 23.8246C17.7085 24.3456 17.9061 24.8216 18.2744 25.1899L28.5145 35.4749C28.8783 35.8387 29.3633 36.0408 29.8798 36.0408C30.3963 36.0408 30.8814 35.8387 31.2452 35.4749L46.4256 20.2495C46.7939 19.8812 46.9915 19.4052 46.9915 18.8842L47.0813 8.55429C47.0813 8.02881 46.8837 7.55723 46.5154 7.18895C46.2325 6.86557 45.7879 6.68143 45.1591 6.62305L34.8202 6.71287Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.902 37.0746C29.1385 37.0746 28.3571 36.7468 27.8091 36.2033L17.5241 25.9633C16.9537 25.3929 16.6528 24.6518 16.6528 23.8254C16.6528 23.0934 16.9537 22.3478 17.4837 21.7774L17.5421 21.7145L17.4837 21.6517C16.3609 20.4884 16.3834 18.6111 17.5286 17.4658L32.7046 2.28535C33.266 1.72394 34.0116 1.41404 34.7975 1.41404L45.1274 1.32422C46.0122 1.36913 46.7308 1.66555 47.2653 2.19552C47.8177 2.74795 48.1366 3.52943 48.1366 4.33336C48.1366 4.64775 47.912 4.87231 47.5976 4.87231C47.2832 4.87231 47.0587 4.63877 47.0587 4.33336C47.0587 3.80789 46.861 3.3363 46.4928 2.96802C46.1604 2.63567 45.7292 2.45602 45.1364 2.40212L34.7975 2.49195C34.272 2.49195 33.8005 2.68956 33.4322 3.05784L18.2517 18.2383C17.5107 18.9794 17.4882 20.1606 18.2068 20.9241L18.2697 20.9914L32.7046 6.55205C33.266 5.99064 34.0116 5.68074 34.7975 5.68074L45.1274 5.59092C45.9583 5.59092 46.6994 5.90081 47.2653 6.46222C47.8177 7.01464 48.1366 7.79612 48.1366 8.60006L48.0467 18.93C48.0467 19.7159 47.7368 20.4615 47.1754 21.0229L31.995 36.2033C31.4336 36.7648 30.688 37.0746 29.902 37.0746ZM34.8424 6.71373C34.3214 6.71373 33.8454 6.91135 33.4771 7.27963L18.2966 22.4601C17.9283 22.8284 17.7307 23.3044 17.7307 23.8254C17.7307 24.3464 17.9283 24.8225 18.2966 25.1908L28.5367 35.4758C28.9005 35.8396 29.3856 36.0417 29.902 36.0417C30.4185 36.0417 30.9036 35.8396 31.2674 35.4758L46.4478 20.2504C46.8161 19.8821 47.0137 19.406 47.0137 18.885L47.1036 8.55515C47.1036 8.02967 46.906 7.55809 46.5377 7.1898C46.2547 6.86643 45.8101 6.68229 45.1813 6.62391L34.8424 6.71373Z",
					fill: "#D9D9D9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.5463 15.8307C39.8367 15.8307 39.19 15.5613 38.678 15.0493C38.166 14.5373 37.8965 13.8905 37.8965 13.1809C37.8965 12.5252 38.1749 11.8605 38.6825 11.308C39.154 10.8365 39.8367 10.5625 40.5463 10.5625C41.2559 10.5625 41.9386 10.8365 42.4147 11.3125C42.9267 11.8245 43.1962 12.4713 43.1962 13.1809C43.1962 13.8905 42.9042 14.5597 42.4147 15.0493C41.9027 15.5613 41.2559 15.8307 40.5463 15.8307ZM40.5912 11.609C40.1736 11.609 39.7469 11.7886 39.4505 12.085C39.1181 12.368 38.9744 12.7587 39.0193 13.2348C39.0193 13.6435 39.1945 14.0702 39.4954 14.3666C39.7963 14.6675 40.1915 14.8292 40.6137 14.8292C41.0359 14.8292 41.4356 14.663 41.732 14.3666C42.0509 14.0477 42.2081 13.6749 42.2081 13.2258C42.2081 12.8081 42.0284 12.3815 41.732 12.085C41.4131 11.7662 41.0404 11.609 40.5912 11.609Z",
					fill: "#D9D9D9"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_580_65099",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 64,
				height: 40,
				fill: "white",
				transform: "translate(0.344727 0.824219)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgEmptyLabels);
export { ForwardRef as ReactComponent };
